import { addToCalendar } from '../plugins/add-to-calendar';

class Calendar {
    constructor() {
        this.calendar = document.querySelectorAll('.js-add-to-calendar');
        if (this.calendar.length) {
            this.calendar.forEach((calendar) => {
                this.bindCalendar(calendar);
            });
        }
    }

    bindCalendar(item) {
        document.addEventListener('click', (evt) => {
            let targetElement = evt.target;

            do {
                if (targetElement.classList && (targetElement.classList.contains('js-add-to-calendar') || targetElement.classList.contains('add-to-calendar-widget'))) {
                    return;
                }
                targetElement = targetElement.parentNode;
            } while (targetElement);
            this.closeCalendar();
        });

        item.addEventListener('click', (e) => {
            this.closeCalendar();
            const myCalendar = addToCalendar({
                options: {
                    class: 'my-class',

                    // You can pass an ID. If you don't, one will be generated for you
                    id: 'my-calendar',
                },
                data: {
                    // Event title
                    title: item.dataset.title,

                    // Event start date
                    start: new Date(item.dataset.date),

                    // Event timezone. Will convert the given time to that zone
                    timezone: item.dataset.timezone ? item.dataset.timezone : 'Europe/Paris',

                    // Event duration (IN MINUTES)
                    duration: item.dataset.duration ? item.dataset.duration : 60,

                    // You can also choose to set an end time
                    // If an end time is set, this will take precedence over duration
                    // end: new Date('June 15, 2013 23:00'),

                    // You can also choose to set 'all day'
                    // If this is set, this will override end time, duration and timezone
                    // allday:true,

                    // Event Address
                    address: item.dataset.address ? item.dataset.address : '',

                    // Event Description
                    description: item.dataset.description ? item.dataset.description : '',
                },
            });
            item.appendChild(myCalendar);
        });
    }

    closeCalendar() {
        if (document.getElementById('my-calendar')) {
            document.getElementById('my-calendar').remove();
        }
    }
}

export default Calendar;
